module.exports = __webpack_public_path__ + "static/heroOlympoUrbano-2fde0bb7e6d4f4f598e72d87c23a5593.png";